<template lang="pug">
div(:style="'min-height:' + h")
  .px-0.white.detail-head.head-border
    el-row.pl-5
      el-col(:span="8")
        Breadcrumb(:data="items")
      el-col.pt-5.text-right(:span="15")
        el-button(
          v-if="true",
          type="primary",
          size="mini",
          @click="$router.go(-1)"
        ) 返回
  div(style="height: 70px")
  el-main.white.pa-3.ma-4
    el-alert(
      v-if="formAuth.checkstatus == 5",
      :title="'驳回原因:' + formAuth.remark + '。操作时间:' + formAuth.update_time",
      type="error",
      :closable="false"
    )
    el-row.py-3(type="flex", justify="center", :gutter="20")
      el-col(:span="12")
        .my-2.ml-5.title 供应商详情：
        el-form(
          :model="formAuth",
          ref="formAuth",
          label-width="145px",
          :disabled="disabled",
          size="mini",
          :rules="rules"
        )
          el-form-item(label="管理组织", prop="pk_org")
            el-select.w-100(v-model="formAuth.pk_org")
              el-option(
                v-for="item in purchase_org",
                :key="item.pk_org",
                :label="item.name",
                :value="item.pk_org"
              )
          el-form-item(
            label="供应商分类",
            prop="pk_supplierclass",
            v-if="formAuth.checkstatus != 2"
          )
            el-select.w-100(v-model="formAuth.pk_supplierclass")
              el-option(
                v-for="item in gysfl",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              )
          el-form-item(
            label="业务类型",
            prop="pk_bustype",
            v-if="formAuth.checkstatus != 2"
          )
            el-select.w-100(v-model="formAuth.pk_bustype")
              el-option(
                v-for="item in ywlx",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              )
          el-form-item(label="企业名称/个人名称", prop="name")
            el-input(v-model="formAuth.name")
          el-form-item(v-if="formAuth.type == 1", label="公司地址", prop="address")
            el-input(v-model="formAuth.address")
          el-form-item(
            v-if="formAuth.type == 1",
            label="注册资金",
            prop="registered_funds"
          )
            el-input(v-model="formAuth.registered_funds")
          el-form-item(
            v-if="formAuth.type == 1",
            label="法人姓名",
            prop="registrant"
          )
            el-input(v-model="formAuth.registrant")
          el-form-item(
            v-if="formAuth.type == 1",
            label="法人电话",
            prop="registrant_phone"
          )
            el-input(v-model="formAuth.registrant_phone")
          el-form-item(v-if="formAuth.type == 1", label="经营范围", prop="scope")
            el-input(v-model="formAuth.scope")
          el-form-item(
            v-if="formAuth.type == 1",
            label="纳税等级",
            prop="tax_class"
          )
            el-select.w-100(v-model="formAuth.tax_class")
              el-option(label="A级纳税人", value="A级纳税人")
              el-option(label="B级纳税人", value="B级纳税人")
              el-option(label="C级纳税人", value="C级纳税人")
              el-option(label="D级纳税人", value="D级纳税人")
              el-option(label="M级纳税人", value="M级纳税人")
          el-form-item(
            v-if="formAuth.type == 1",
            label="纳税等级证明",
            prop="img_tax_class"
          )
            el-upload.auth-uploader(
              v-if="type == 2",
              :show-file-list="false",
              :headers="http_header",
              accept=".jpg,.png,.jpeg",
              :action="path",
              :on-success="(res, file) => { return handleSuccess(res, file, 7); }",
              :before-upload="(file) => { return beforeUpload(file, 7); }"
            )
              img.auth-img(
                v-if="formAuth.img_tax_class",
                :src="img_url + formAuth.img_tax_class"
              )
              i.el-icon-plus.auth-uploader-icon(v-else)
            el-image(
              v-else,
              :src="img_url + formAuth.img_tax_class",
              width="125",
              height="70",
              :preview-src-list="[img_url + formAuth.img_tax_class]"
            )
          el-form-item(
            v-if="formAuth.type == 1",
            label="统一社会信用代码",
            prop="credit_code"
          )
            el-input(
              v-model="formAuth.credit_code",
              :class="{ redColor: formAuth.credit_code == qxb.credit_code ? false : true }"
            )
          el-form-item(
            v-if="formAuth.type == 1",
            label="营业执照许可证",
            prop="img_business_license"
          )
            el-upload.auth-uploader(
              v-if="type == 2",
              :show-file-list="false",
              :headers="http_header",
              accept=".jpg,.png,.jpeg",
              :action="path",
              :on-success="(res, file) => { return handleSuccess(res, file, 1); }",
              :before-upload="(file) => { return beforeUpload(file, 1); }"
            )
              img.auth-img(
                v-if="formAuth.img_business_license",
                :src="img_url + formAuth.img_business_license"
              )
              i.el-icon-plus.auth-uploader-icon(v-else)
            el-image(
              v-else,
              :src="img_url + formAuth.img_business_license",
              :preview-src-list="[img_url + formAuth.img_business_license]",
              width="125",
              height="70"
            )
          el-form-item(
            v-if="formAuth.type == 1",
            label="开户行许可证",
            prop="img_bank_license"
          )
            el-upload.auth-uploader(
              v-if="type == 2",
              :show-file-list="false",
              :headers="http_header",
              accept=".jpg,.png,.jpeg",
              :action="path",
              :on-success="(res, file) => { return handleSuccess(res, file, 2); }",
              :before-upload="(file) => { return beforeUpload(file, 2); }"
            )
              img.auth-img(
                v-if="formAuth.img_bank_license",
                :src="img_url + formAuth.img_bank_license"
              )
              i.el-icon-plus.auth-uploader-icon(v-else)
            el-image(
              v-else,
              :src="img_url + formAuth.img_bank_license",
              width="125",
              height="70",
              :preview-src-list="[img_url + formAuth.img_bank_license]"
            )
          el-form-item(
            v-if="formAuth.type == 1",
            label="法人身份证",
            prop="img_registrant_id_card"
          )
            el-row(v-if="type == 2", type="flex", justify="center")
              el-col(:span="12")
                el-upload.auth-uploader(
                  :show-file-list="false",
                  :headers="http_header",
                  accept=".jpg,.png,.jpeg",
                  :action="path",
                  :on-success="(res, file) => { return handleSuccess(res, file, 3); }",
                  :before-upload="(file) => { return beforeUpload(file, 3); }"
                )
                  img.auth-img(
                    v-if="formAuth.img_registrant_id_card",
                    :src="img_url + formAuth.img_registrant_id_card"
                  )
                  i.el-icon-plus.auth-uploader-icon(v-else) 法人身份证正面
              el-col(:span="12")
                el-upload.auth-uploader(
                  :show-file-list="false",
                  :headers="http_header",
                  accept=".jpg,.png,.jpeg",
                  :action="path",
                  :on-success="(res, file) => { return handleSuccess(res, file, 4); }",
                  :before-upload="(file) => { return beforeUpload(file, 4); }"
                )
                  img.auth-img(
                    v-if="formAuth.img_registrant_id_card_back",
                    :src="img_url + formAuth.img_registrant_id_card_back"
                  )
                  i.el-icon-plus.auth-uploader-icon(v-else) 法人身份证反面
            el-row(v-else, type="flex", justify="center")
              el-col(:span="12")
                el-image(
                  :src="img_url + formAuth.img_registrant_id_card",
                  width="125",
                  height="70",
                  :preview-src-list="[img_url + formAuth.img_registrant_id_card]"
                )
              el-col(:span="12")
                el-image(
                  :src="img_url + formAuth.img_registrant_id_card_back",
                  width="125",
                  height="70",
                  :preview-src-list="[img_url + formAuth.img_registrant_id_card_back]"
                )
          el-form-item(label="注册人身份证", prop="img_agent_id_card")
            el-row(v-if="type == 2", type="flex", justify="center")
              el-col(:span="12")
                el-upload.auth-uploader(
                  :show-file-list="false",
                  :headers="http_header",
                  accept=".jpg,.png,.jpeg",
                  :action="path",
                  :on-success="(res, file) => { return handleSuccess(res, file, 5); }",
                  :before-upload="(file) => { return beforeUpload(file, 5); }"
                )
                  img.auth-img(
                    v-if="formAuth.img_agent_id_card",
                    :src="img_url + formAuth.img_agent_id_card"
                  )
                  i.el-icon-plus.auth-uploader-icon(v-else) 注册人身份证正面
              el-col(:span="12")
                el-upload.auth-uploader(
                  :show-file-list="false",
                  :headers="http_header",
                  accept=".jpg,.png,.jpeg",
                  :action="path",
                  :on-success="(res, file) => { return handleSuccess(res, file, 6); }",
                  :before-upload="(file) => { return beforeUpload(file, 6); }"
                )
                  img.auth-img(
                    v-if="formAuth.img_agent_id_card_back",
                    :src="img_url + formAuth.img_agent_id_card_back"
                  )
                  i.el-icon-plus.auth-uploader-icon(v-else) 注册人身份证反面
            el-row(v-else, type="flex", justify="center")
              el-col(:span="12")
                el-image(
                  :src="img_url + formAuth.img_agent_id_card",
                  width="125",
                  height="70",
                  :preview-src-list="[img_url + formAuth.img_agent_id_card]"
                )
              el-col(:span="12")
                el-image(
                  :src="img_url + formAuth.img_agent_id_card_back",
                  width="125",
                  height="70",
                  :preview-src-list="[img_url + formAuth.img_agent_id_card_back]"
                )
          el-form-item(label="级别")
            el-select.w-100(v-model="formAuth.supplier_level", disabled)
              el-option(
                v-for="(item, key) in gysdj",
                :key="key",
                :label="item.name",
                :value="item.code"
              )
          el-form-item(label="是否拉黑")
            el-switch(
              v-model="formAuth.is_blacklist",
              :active-value="2",
              :inactive-value="1",
              disabled
            )
          //- el-form-item(label="开户行名称" prop="bank_name")
          //-   el-input(v-model="formAuth.bank_name")
          //- el-form-item(label="开户行行号" prop="bank_code")
          //-   el-input(v-model="formAuth.bank_code")
          //- el-form-item(label="银行账号" prop="bank_account")
          //-   el-input(v-model="formAuth.bank_account")
          el-form-item(label="联系人", prop="contact")
            el-input(v-model="formAuth.contact")
          el-form-item(label="联系电话", prop="contact_phone")
            el-input(v-model="formAuth.contact_phone")
          el-form-item(v-if="formAuth.type == 2", label="身份证号", prop="id_num")
            el-input(v-model="formAuth.id_num")
      el-col(v-if="formAuth.type == 1", :span="12")
        .my-2.ml-5.title 启信宝信息：
        el-form(:model="qxb", label-width="130px", disabled, size="mini")
          el-form-item(label="管理组织")
          el-form-item(label="企业名称")
            el-input(v-model="qxb.name")
          el-form-item(label="公司地址")
            el-input(v-model="qxb.address")
          el-form-item(label="注册资金")
            el-input(v-model="qxb.registered_funds")
          el-form-item(label="法人姓名")
            el-input(v-model="qxb.registrant")
          el-form-item(label="法人电话")
            el-input(v-model="qxb.registrant_phone")
          el-form-item(label="经营范围")
            el-input(v-model="qxb.scope")
          el-form-item(label="纳税等级")
          el-form-item(label="纳税等级证明")
          el-form-item(label="统一社会信用代码")
            el-input(v-model="qxb.credit_code")
          el-form-item(label="营业执照许可证")
          el-form-item(label="开户行许可证")
          el-form-item(label="法人身份证")
          el-form-item(label="注册人身份证")
          el-form-item(label="级别")
          el-form-item(label="是否拉黑")
          el-form-item(label="开户行名称")
          el-form-item(label="开户行行号")
          el-form-item(label="银行账号")
          el-form-item(label="联系人")
          el-form-item(label="联系电话")
    el-row
      el-col(:offset="4", :span="16")
        div
          .fl.subheading 银行账号
          .fr
            el-button(
              type="primary",
              size="mini",
              @click="addBank",
              :disabled="disabled"
            ) 新增
        el-table(:data="bankData", row-key="id", size="mini")
          el-table-column(prop="bank_code", label="开户行行号")
          el-table-column(prop="bank_name", label="开户行名称")
          el-table-column(prop="bank_account", label="银行账号")
          el-table-column(prop="name_account", label="账户名")
          el-table-column(prop="ower_account", label="账户持有人")
          el-table-column(prop="is_private", label="是否私人账户")
            template(slot-scope="scope")
              span {{ scope.row.is_private == "Y" ? "是" : "否" }}
          el-table-column(label="操作", width="150", key="op")
            template(slot-scope="scope")
              el-button(
                type="primary",
                size="mini",
                plain,
                :disabled="disabled",
                @click="copyBank(scope.row)"
              ) 复制
              el-button(
                type="danger",
                size="mini",
                plain,
                :disabled="disabled",
                @click="del(scope.row.id)"
              ) 删除
    el-row.mt-4
      el-col(:offset="4", :span="16")
        .subheading 供应商升降日志
        el-table(:data="levelData", row-key="id", size="mini")
          el-table-column(prop="create_date", label="变更时间")
          el-table-column(prop="creator", label="变更人员")
          el-table-column(prop="before_levelName", label="变更前级别")
          el-table-column(prop="after_levelName", label="变更后级别")
          el-table-column(prop="remark", label="变更备注")
    el-row.mt-4
      el-col(:offset="4", :span="16")
        .subheading 拉黑日志
        el-table(:data="blackData", row-key="id", size="mini")
          el-table-column(prop="create_date", label="变更时间")
          el-table-column(prop="creator", label="变更人员")
          el-table-column(prop="remark", label="变更备注")
          el-table-column(prop="status", label="状态")
            template(slot-scope="scope")
              span {{ scope.row.status == 1 ? "取消拉黑" : "拉黑" }}
    el-row.py-3(
      v-if="formAuth.checkstatus == 2 && this.type == 3",
      type="flex",
      justify="center",
      :gutter="5"
    )
      el-col.text-center(:span="2")
        el-button(type="primary", @click="dialogFormVisible1 = true") 通过
      //- el-col.text-center(:span="2")
      //-   el-button(type="primary" plain @click="showDialog(4)") 不通过
      el-col.text-center(:span="2")
        el-button(type="primary", plain, @click="showDialog(5)") 不通过
    el-row.py-3(
      v-if="this.type == 2",
      type="flex",
      justify="center",
      :gutter="5"
    )
      el-col.text-center(:span="2")
        el-button(type="primary", @click="edit('formAuth')") 保存
      el-col.text-center(:span="2")
        el-button(type="primary", plain, @click="$router.go(-1)") 返回
  el-dialog.dialog(
    :title="title",
    :visible.sync="dialogFormVisible",
    width="380px",
    :show-close="false",
    :destroy-on-close="true",
    :append-to-body="true",
    :close-on-press-escape="false",
    :close-on-click-modal="true"
  )
    el-form(
      :model="form",
      ref="form",
      size="mini",
      label-width="60px",
      :rules="rules"
    )
      el-form-item(label="理由", prop="remark")
        el-input(
          v-model="form.remark",
          type="textarea",
          :autosize="{ minRows: 2, maxRows: 4 }"
        )
    .dialog-footer(slot="footer")
      el-button(size="mini", @click="dialogFormVisible = false") 取 消
      el-button(size="mini", type="primary", @click="submitForm") 确 定
  el-dialog.dialog(
    title="选择供应商分类",
    :visible.sync="dialogFormVisible1",
    width="380px",
    :show-close="false",
    :destroy-on-close="true",
    :append-to-body="true",
    :close-on-press-escape="false",
    :close-on-click-modal="true"
  )
    el-form(
      :model="form",
      ref="form",
      size="mini",
      label-width="100px",
      :rules="rules"
    )
      el-form-item(label="供应商分类", prop="pk_supplierclass")
        el-radio-group(v-model="form.pk_supplierclass")
          el-radio.w-100.mb-2(
            v-for="item in gysfl",
            :key="item.code",
            :label="item.code"
          ) {{ item.name }}
      el-form-item(label="业务类型", prop="pk_bustype")
        el-radio-group(v-model="form.pk_bustype")
          el-radio.w-100.mb-2(
            v-for="item in ywlx",
            :key="item.code",
            :label="item.code"
          ) {{ item.name }}
    .dialog-footer(slot="footer")
      el-button(size="mini", @click="dialogFormVisible1 = false") 取 消
      el-button(size="mini", type="primary", @click="supplierAuth(3)") 确 定
  el-dialog.dialog(
    title="新增银行账号",
    :visible.sync="dialogFormVisible2",
    width="380px",
    :show-close="false",
    :destroy-on-close="true",
    :append-to-body="true",
    :close-on-press-escape="false",
    :close-on-click-modal="true"
  )
    el-form(
      :model="form1",
      ref="form1",
      size="mini",
      label-width="100px",
      :rules="rules"
    )
      el-form-item(label="开户行", prop="bank_code")
        el-select.w-100(
          v-model="form1.bank_code",
          filterable,
          remote,
          placeholder="请搜索开户行",
          :remote-method="getBankList",
          :loading="loadingBank"
        )
          el-option(
            v-for="item in bankList",
            :key="item.id",
            :label="item.name",
            :value="item.code"
          )
      el-form-item(
        label="银行账号",
        prop="bank_account",
        @keyup.native="form1.bank_account = $event.target.value.replace(/\\s+/g, '')"
      )
        el-input(v-model.trim="form1.bank_account")
      el-form-item(label="账户名", prop="name_account")
        el-input(
          v-model.trim="form1.name_account",
          @keyup.native="form1.name_account = $event.target.value.replace(/\\s+/g, '')"
        )
      el-form-item(label="账户持有人", prop="ower_account")
        el-input(
          v-model.trim="form1.ower_account",
          @keyup.native="form1.ower_account = $event.target.value.replace(/\\s+/g, '')"
        )
      el-form-item(label="是否私人账户", prop="is_private")
        el-select.w-100(
          v-model="form1.is_private",
          filterable,
          placeholder="是否私人账户"
        )
          el-option(label="是", value="Y")
          el-option(label="否", value="N")
    .dialog-footer(slot="footer")
      el-button(size="mini", @click="cancel") 取 消
      el-button(size="mini", type="primary", @click="submitForm1") 确 定
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          path: "/admin/supply_manage",
          meta: {
            title: "供应商管理",
          },
        },
        {
          path: this.$route.path,
          meta: {
            title: "详情",
          },
        },
      ],
      h: "",
      loading: false,
      formAuth: {
        pk_org: "",
        name: "",
        address: "",
        registered_funds: "",
        registrant: "",
        registrant_phone: "",
        scope: "",
        tax_class: "",
        img_tax_class: "",
        credit_code: "",
        img_business_license: "", //营业许可证
        img_bank_license: "", //开户行许可证
        img_registrant_id_card: "", //法人身份证正面
        img_registrant_id_card_back: "", //法人身份证反面
        img_agent_id_card: "", //代理人身份证正面
        img_agent_id_card_back: "", //代理人身份证反面
        // bank_name: "",
        // bank_code: "",
        // bank_account: "",
        id_num: "",
        supplier_level: "",
        is_blacklist: "",
        pk_supplierclass: "",
        pk_bustype: "",
      },
      qxb: {
        pk_org: "",
        name: "",
        address: "",
        registered_funds: "",
        registrant: "",
        registrant_phone: "",
        scope: "",
        tax_class: "",
        img_tax_class: "",
        credit_code: "",
        img_business_license: "", //营业许可证
        img_bank_license: "", //开户行许可证
        img_registrant_id_card: "", //法人身份证正面
        img_registrant_id_card_back: "", //法人身份证反面
        img_agent_id_card: "", //代理人身份证正面
        img_agent_id_card_back: "", //代理人身份证反面
        // bank_name: "",
        // bank_code: "",
        // bank_account: "",
      },
      imgUrl: "",
      imgDialogVisible: false,
      title: "不通过理由",
      form: {
        code: "",
        remark: "",
        checkstatus: null,
        pk_supplierclass: "Z002",
        pk_bustype: "",
      },
      dialogFormVisible: false,
      rules: {
        remark: [{ required: true, message: "请填写理由", trigger: "blur" }],
        pk_supplierclass: [
          { required: true, message: "请选择供应商分类", trigger: "change" },
        ],
        pk_bustype: [
          { required: true, message: "请选择业务类型", trigger: "change" },
        ],
        pk_org: [
          { required: true, message: "请选择管理组织", trigger: "change" },
        ],
        name: [
          {
            required: true,
            message: "请填写企业名称/个体名称",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请填写注册地址", trigger: "blur" },
        ],
        registered_funds: [
          { required: true, message: "请填写注册资金", trigger: "blur" },
        ],
        registrant: [
          { required: true, message: "请填写法人姓名", trigger: "blur" },
        ],
        registrant_phone: [
          { required: true, message: "请填写法人电话", trigger: "blur" },
        ],
        scope: [{ required: true, message: "请填写经营范围", trigger: "blur" }],
        tax_class: [
          { required: true, message: "请填写纳税等级", trigger: "blur" },
        ],
        img_tax_class: [
          { required: true, message: "请上传纳税等级证明", trigger: "blur" },
        ],
        credit_code: [
          {
            required: true,
            message: "请填写统一社会信用代码",
            trigger: "blur",
          },
        ],
        img_business_license: [
          { required: true, message: "请上传营业许可证", trigger: "blur" },
        ],
        img_bank_license: [
          { required: true, message: "请上传开户行许可证", trigger: "blur" },
        ],
        img_registrant_id_card: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                this.formAuth.img_registrant_id_card &&
                this.formAuth.img_registrant_id_card_back
              ) {
                callback();
              } else {
                callback("请上传法人身份证正反面");
              }
            },
            trigger: "blur",
          },
        ],
        img_agent_id_card: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                this.formAuth.img_agent_id_card &&
                this.formAuth.img_agent_id_card_back
              ) {
                callback();
              } else {
                callback("请上传注册人身份证正反面");
              }
            },
            trigger: "blur",
          },
        ],
        bank_code: [
          { required: true, message: "请选择开户行", trigger: "change" },
        ],
        bank_account: [
          { required: true, message: "请填写银行账号", trigger: "blur" },
        ],
        name_account: [
          { required: true, message: "请填写账户名", trigger: "blur" },
        ],
        ower_account: [
          { required: true, message: "请填写账户持有人", trigger: "blur" },
        ],
        is_private: [
          { required: true, message: "请选择是否私人账户", trigger: "change" },
        ],
        contact: [{ required: true, message: "请填写联系人", trigger: "blur" }],
        contact_phone: [
          { required: true, message: "请填写联系电话", trigger: "blur" },
        ],
        id_num: [{ required: true, message: "请填身份证号", trigger: "blur" }],
      },
      checkstatus: null,
      gysfl: [],
      ywlx: [],
      dialogFormVisible1: false,
      gysdj: [],
      disabled: true,
      imageUrl: "",
      path: this.$api.file.upload_pic,
      img_url: this.$api.file.img_url,
      levelData: [],
      blackData: [],
      bankData: [],
      form1: {
        code: "",
        bank_code: "",
        bank_account: "",
        name_account: "",
        ower_account: "",
        is_private: "",
      },
      dialogFormVisible2: false,
      bankList: [],
      loadingBank: false,
    };
  },
  props: ["user_code", "type"],
  methods: {
    // eslint-disable-next-line no-unused-vars
    beforeUpload(file, type) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        this.$notify({
          message: "上传图片只能是jpg/png/jpeg格式!",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // eslint-disable-next-line no-unused-vars
    handleSuccess(res, file, type) {
      if (res.code == 200) {
        switch (type) {
          case 1:
            this.formAuth.img_business_license = res.data;
            this.$refs["formAuth"].$children[10].onFieldBlur();
            break;
          case 2:
            this.formAuth.img_bank_license = res.data;
            this.$refs["formAuth"].$children[11].onFieldBlur();
            break;
          case 3:
            this.formAuth.img_registrant_id_card = res.data;
            this.$refs["formAuth"].$children[12].onFieldBlur();
            break;
          case 4:
            this.formAuth.img_registrant_id_card_back = res.data;
            this.$refs["formAuth"].$children[12].onFieldBlur();
            break;
          case 5:
            this.formAuth.img_agent_id_card = res.data;
            if (this.formAuth.type == 1) {
              this.$refs["formAuth"].$children[13].onFieldBlur();
            } else {
              this.$refs["formAuth"].$children[2].onFieldBlur();
            }
            break;
          case 6:
            this.formAuth.img_agent_id_card_back = res.data;
            if (this.formAuth.type == 1) {
              this.$refs["formAuth"].$children[13].onFieldBlur();
            } else {
              this.$refs["formAuth"].$children[2].onFieldBlur();
            }
            break;
          case 7:
            this.formAuth.img_tax_class = res.data;
            this.$refs["formAuth"].$children[8].onFieldBlur();
            break;
          default:
            break;
        }
      }
    },
    showDialog(type) {
      if (type == 4) {
        this.title = "不通过理由";
      } else {
        this.title = "驳回理由";
      }
      this.checkstatus = type;
      this.dialogFormVisible = true;
    },
    async supplierAuth(type) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.form.checkstatus = type;
          let res = await this.$api.supplier.supplierAuth(this.form);
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        }
      });
    },
    edit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          let res = await this.$api.supplier.edit(this.formAuth);
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        } else {
          return false;
        }
      });
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.supplierAuth(this.checkstatus);
        } else {
          return false;
        }
      });
    },
    async getQXB() {
      if (!this.formAuth.name) {
        this.$notify({
          message: "请填写企业名称",
          type: "error",
        });
        return false;
      }
      let res = await this.$api.supplier.qxborg_info({
        name: this.formAuth.name,
      });
      if (res) {
        this.qxb.name = res.data.name;
        this.qxb.address = res.data.address;
        this.qxb.registered_funds = res.data.regist_capi;
        this.qxb.registrant = res.data.oper_name;
        this.qxb.registrant_phone = res.data.contact.telephone; //法人电话
        this.qxb.scope = res.data.scope;
        this.qxb.credit_code = res.data.credit_no;
      }
    },
    async getSupplierInfo() {
      let res = await this.$api.supplier.getSupplierInfo({
        user_code: this.user_code,
      });
      if (res) {
        this.formAuth = res.data;
        this.form.code = res.data.code;
        this.form1.code = res.data.code;
        if (this.formAuth.type == 1) this.getQXB();
        this.getLevelList();
        this.getBlackList();
        this.getBankData();
      }
    },
    async getLevelList() {
      let res = await this.$api.supplier.getSupplierList({
        code: this.formAuth.code,
      });
      if (res) {
        this.levelData = res.data;
      }
    },
    async getBlackList() {
      let res = await this.$api.supplier.getBlackList({
        code: this.formAuth.code,
      });
      if (res) {
        this.blackData = res.data;
      }
    },
    async getBankData() {
      let res = await this.$api.supplier.getBankList(this.formAuth.code);
      if (res) {
        this.bankData = res.data;
      }
    },
    cancel() {
      this.$refs["form1"].resetFields();
      this.dialogFormVisible2 = false;
    },
    addBank() {
      this.dialogFormVisible2 = true;
      this.$nextTick(function () {
        this.$refs["form1"].resetFields();
        this.form1.bank_code = "";
        this.form1.bank_account = "";
        this.form1.is_private = "";
        this.form1.name_account = "";
        this.form1.ower_account = "";
      });
    },
    copyBank(e) {
      this.dialogFormVisible2 = true;
      this.form1.bank_account = e.bank_account;
      this.form1.bank_code = e.bank_code;
      this.form1.is_private = e.is_private;
      this.form1.name_account = e.name_account;
      this.form1.ower_account = e.ower_account;
    },
    submitForm1() {
      this.$refs["form1"].validate(async (valid) => {
        if (valid) {
          let res = await this.$api.supplier.addBank(this.form1);
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.$refs["form1"].resetFields();
            this.getBankData();
            this.dialogFormVisible2 = false;
          }
        } else {
          return false;
        }
      });
    },
    del(id) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await this.$api.supplier.delBank(id);
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.getBankData();
          }
        })
        .catch(() => {});
    },
    async getBankList(query) {
      if (!query) {
        return false;
      }
      this.loadingBank = true;
      let res = await this.$api.global.getBankList({
        key_name: query,
        page_num: 1,
        page_size: 100,
      });
      this.loadingBank = false;
      if (res) {
        this.bankList = res.data;
      }
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    this.getSupplierInfo();
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseOrg();
    this.getDefdoc(this, { code: "gysfl" });
    if (this.type == 2) {
      this.items[1].meta.title = "编辑";
      this.disabled = false;
    } else {
      this.items[1].meta.title = "详情";
      this.disabled = true;
    }
    this.getDefdoc(this, { code: "gysdj" });
    this.getDefdoc(this, { code: "ywlx" });
  },
};
</script>
<style lang="less" scoped>
/deep/ .redColor .el-input__inner {
  color: red;
  font-weight: 900;
  font-size: 16px;
}
</style>
